import React from "react";
import coinsJpg from "../../assets/coins.jpg";

import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  Typography,
  makeStyles,
} from "@material-ui/core";

import UpdateIcon from "@material-ui/icons/Update";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import { ReactComponent as SplitwiseIcon } from "../../assets/splitwise_icon.svg";
import { ReactComponent as VenmoIcon } from "../../assets/venmo_icon.svg";
import AddIcon from "@material-ui/icons/Add";
import StarIcon from "@material-ui/icons/Star";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";

import PlanCard from "../../components/PlanCard";
import ActionButton from "./ActionButton";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  infoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paragraph: {
    marginTop: theme.spacing(2),
  },
  formContainer: {
    maxWidth: 400,
  },
}));
//TODO: this image doesn't look great on mobile.
export default () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.header}>
        <Typography variant="h4">Which plan is right for you?</Typography>
      </div>
      <div
        style={{
          background: `url(${coinsJpg})`,
          backgroundSize: "cover",
          backgroundClip: "border-box",
          backgroundPositionY: -423,
          overflow: "hidden",
          padding: 20,
        }}
      >
        <Grid container spacing={3} className={classes.cardContainer}>
          <PlanCard
            style={{ marginLeft: "auto" }}
            type="standard"
            Icon={MoneyOffIcon}
            left={true}
            action={<ActionButton color={true}>sign up</ActionButton>}
          ></PlanCard>
          <PlanCard
            style={{ marginRight: "auto" }}
            type="pro"
            Icon={StarIcon}
            monthlyPrice={5}
            numAccounts={5}
            action={<ActionButton color={true}>sign up</ActionButton>}
          >
            <ListItem>
              <ListItemIcon>
                <HourglassEmptyIcon />
              </ListItemIcon>
              Pending transactions
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <UpdateIcon />
              </ListItemIcon>
              Recurring transactions
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <AddIcon />
              </ListItemIcon>
              All future features
            </ListItem>
          </PlanCard>
        </Grid>
      </div>
    </>
  );
};
